import { Avatar } from "@mui/material";

const usersUrl = "https://reqres.in/api/users";
const resourceUrl = "https://reqres.in/api/unknown";
const covidUrl = "https://data.covid19india.org/data.json";
const baseCovidurl = "https://disease.sh/v3/covid-19";
const covidTrackerUrl = "https://disease.sh/v3/covid-19/countries";
const covidWorldWide = "https://disease.sh/v3/covid-19/all";

const columns_users = [
  {
    label: "Id",
    field: "id",
    width: 150,
  },
  {
    label: "Email",
    field: "email",
    width: 270,
  },
  {
    label: "FirstName",
    field: "first_name",
    width: 270,
  },
  {
    label: "LastName",
    field: "last_name",
    width: 270,
  },

  {
    label: "User",
    field: "user",
    width: 200,
    renderCell: (params) => {
      return (
        <div>
          <Avatar
            alt={params.row.first_name}
            src={params.row.avatar}
            sx={{ width: 24, height: 24 }}
          />
        </div>
      );
    },
  },
];

const resourcesColumns = [
  {
    label: "Id",
    field: "id",
    width: 150,
  },
  {
    label: "Name",
    field: "name",
    width: 150,
  },
  {
    label: "Color",
    field: "color",
    width: 150,
  },
  {
    label: "Pantone_value",
    field: "pantone_value",
    width: 150,
  },
  {
    label: "Year",
    field: "year",
    width: 150,
  },
];

export {
  columns_users,
  usersUrl,
  resourceUrl,
  resourcesColumns,
  covidUrl,
  covidWorldWide,
  covidTrackerUrl,
  baseCovidurl,
};

export const control = {
  INPUT: "input",
  DATE: "date",
  DATEMUI: "datemui",
};
